// import React, { useEffect, useState } from "react";
// import { Checkbox, Modal, Table } from "antd";
// import styled from "styled-components";
// import Button from "atoms/Button";
// import moment from "moment";
// import { generateNiceWeekFromWeek } from "pages/TimeSheet/useWeekData";
// import { getUserList } from "redux/selectors";
// import { useSelector } from "react-redux";

// export const ViewClaims = ({
// 	isModalVisible,
// 	setIsModalVisible,
// 	addClaims,
// 	setaddClaims,
// 	viewClims,
// 	claimsDataSource,
// 	isViewClims,
// 	update,
// 	activeclaimsIds = [],
// }) => {
// 	const userList = useSelector(getUserList);
// 	const [selectedKeys, setSelectedKeys] = useState(new Set());
// 	const [expandedRows, setExpandedRows] = useState({});
// 	useEffect(() => {
// 		if (update && addClaims?.length > 0) {
// 			const ids = new Set(addClaims.map((c) =>
// 				c?.claimsId?.claimsid  // nested: { claimsId: { claimsid: "5" } }
// 				?? c?.claimsid          // unwrapped: { claimsid: "5" }
// 				?? c?.claimsId          // flat string id
// 				?? c?.id
// 				?? c
// 			));
// 			setSelectedKeys(ids);
// 		}
// 	}, [update, addClaims]);

// 	const claimsColumns = [
// 		!isViewClims
// 			? {
// 				title: "Action",
// 				dataIndex: "action",
// 				key: "action",
// 				render: (_, record) => (
// 					<Checkbox
// 						checked={
// 							activeclaimsIds?.includes(record?.claimsid ?? record?.claimsId) ||
// 							selectedKeys.has(record?.claimsid ?? record?.claimsId ?? record?.id ?? record.key)
// 						}
// 						onChange={(e) =>
// 							handleCheckboxChange(
// 								e,
// 								record?.claimsid ?? record?.claimsId ?? record?.id ?? record.key
// 							)
// 						}
// 						disabled={activeclaimsIds?.includes(record?.claimsid ?? record?.claimsId)}
// 					/>
// 				),
// 			}
// 			: null,
// 		{
// 			title: "Description",
// 			dataIndex: "description",
// 			key: "description",
// 			width: 350,
// 			render: (description, record) => {
// 				const isExpanded = expandedRows[record.key];

// 				return (
// 					<div>
// 						<div
// 							style={{
// 								maxHeight: isExpanded ? "60px" : "48px",
// 								overflowY: isExpanded ? "auto" : "hidden",
// 								overflowX: "hidden",
// 								display: "-webkit-box",
// 								WebkitLineClamp: isExpanded ? "unset" : 2,
// 								WebkitBoxOrient: "vertical",
// 								wordBreak: "break-word",
// 								whiteSpace: "normal",
// 								lineHeight: "1.5",
// 								paddingRight: isExpanded ? "6px" : "0px",
// 							}}
// 						>
// 							{description || "-"}
// 						</div>

// 						{description && description?.length > 80 && (
// 							<span
// 								onClick={() =>
// 									setExpandedRows((prev) => ({
// 										...prev,
// 										[record.key]: !prev[record.key],
// 									}))
// 								}
// 								style={{
// 									color: "#397EF3",
// 									cursor: "pointer",
// 									fontSize: "13px",
// 									fontWeight: 500,
// 									marginTop: "4px",
// 									display: "inline-block",
// 								}}
// 							>
// 								{isExpanded ? "View Less" : "View More"}
// 							</span>
// 						)}
// 					</div>
// 				);
// 			},
// 		},
// 		{
// 			title: "VAT/Non- VAT",
// 			dataIndex: "vat",
// 			key: "vat",
// 			render: (_, record) => <>{record.vat === true ? "VAT" : "NON-VAT"}</>,
// 		},
// 		{
// 			title: "Type",
// 			dataIndex: "type",
// 			key: "type",
// 		},
// 		{
// 			title: "Currency",
// 			dataIndex: "currency",
// 			key: "currency",
// 		},
// 		{
// 			title: "Amount",
// 			dataIndex: "amount",
// 			key: "amount",
// 			render: (_, record) => {
// 				const formattedAmount = new Intl.NumberFormat("en-US").format(
// 					Number(record?.totalamount ?? record?.amount) || 0
// 				);
// 				return <>{formattedAmount}</>;
// 			},
// 		},
// 		{
// 			title: "Submitted By",
// 			dataIndex: "submittedby",
// 			key: "submittedby",
// 			render: (_, record) => {
// 				if (record.submittedby) {
// 					return record.submittedby;
// 				}

// 				if (record.createdby) {
// 					const user = userList.find(
// 						(u) => u.userid === record.createdby
// 					);

// 					return user ? user.fullname : record.createdby;
// 				}

// 				return "-";
// 			},
// 		},
// 		{
// 			title: "Timesheet Week",
// 			dataIndex: "week",
// 			key: "week",
// 			render: (_, record) => (
// 				<span style={{ color: "#397EF3" }}>
// 					{record.week ? generateNiceWeekFromWeek(record.week) : "-"}
// 				</span>
// 			),
// 		},
// 		{
// 			title: "Date",
// 			dataIndex: "date",
// 			key: "date",
// 			render: (_, record) => <>{record.date ? moment(record.date).format("DD-MM-YYYY") : record.dateoflog ? moment(record.dateoflog).format("DD-MM-YYYY") : "-"}</>,
// 		},
// 	].filter(Boolean);

// 	const handleCheckboxChange = (e, key) => {
// 		setSelectedKeys((prevSelectedKeys) => {
// 			const newSelectedKeys = new Set(prevSelectedKeys);
// 			if (e.target.checked) {
// 				newSelectedKeys.add(key);
// 			} else {
// 				newSelectedKeys.delete(key);
// 			}
// 			return newSelectedKeys;
// 		});
// 	};

// 	const claimsData = claimsDataSource
// 		?.filter((record) => record.type !== "Subcontract")
// 		?.map((record, index) => ({
// 			...record,
// 			key: record?.claimsid   // ✅ lowercase — matches API response
// 				?? record?.claimsId
// 				?? record?.id
// 				?? index,
// 		}));

// 	const handleSave = () => {
// 		const selectedRecords = claimsData.filter((record) =>
// 			selectedKeys.has(record.key)
// 		);

// 		const mapedRecords = selectedRecords.map((item, index) => ({
// 			date: new Date(item?.dateoflog) || "",
// 			submittedby: userList.find(
// 				(u) => u.userid === item.createdby
// 			)?.fullname || "",
// 			amount: item?.totalamount || "0",
// 			claimsId: item?.claimsid || "",
// 			non_vat: item?.taxtype === "Non-VAT" ? true : false,
// 			vat: item?.taxtype === "VAT" ? true : false,
// 			description: item?.description || "",
// 			type: item?.type || "",
// 			attachments: item?.attachments || [],
// 			currency: item?.currency || "",
// 			remarks: item?.remarks || "",
// 			status: true,
// 		}));
// 		setaddClaims(mapedRecords);
// 		handleCancel();
// 	};

// 	const handleCancel = () => {
// 		setIsModalVisible(false);
// 	};

// 	return (
// 		<StyledClaimsModal
// 			visible={isModalVisible}
// 			onCancel={handleCancel}
// 			footer={false}
// 		>
// 			<h6>Select Claims:</h6>
// 			<Table
// 				dataSource={claimsData}
// 				columns={claimsColumns}
// 				rowKey={(record) => record.key}
// 				pagination={false}
// 				scroll={{ x: 1000, y: 600 }}
// 			/>
// 			{!isViewClims && (
// 				<div className="text-end mt-2">
// 					<Button
// 						type="primary"
// 						className="cursor-pointer"
// 						onClick={handleCancel}
// 					>
// 						Cancel
// 					</Button>
// 					<Button
// 						type="primary"
// 						className="cursor-pointer"
// 						onClick={handleSave}
// 					>
// 						Save
// 					</Button>
// 				</div>
// 			)}
// 		</StyledClaimsModal>
// 	);
// };

// const StyledClaimsModal = styled(Modal)`
//   width: 1500px !important;
//   z-index: 10;
//   .ant-modal-header {
//     text-transform: uppercase;
//     max-width: 95%;
//   }
//   .ant-modal-body {
//     overflow-y: auto;
//     max-height: 85vh;
//     padding-right: 16px;
//   }
//   ul.ant-pagination {
//     display: none;
//   }
//   .ant-modal-close-x {
//     display: none;
//   }
// `;

import React, { useEffect, useState } from "react";
import { Checkbox, Modal, Table } from "antd";
import styled from "styled-components";
import Button from "atoms/Button";
import moment from "moment";
import { generateNiceWeekFromWeek } from "pages/TimeSheet/useWeekData";
import { getUserList } from "redux/selectors";
import { useSelector } from "react-redux";

const StyledButton = styled(Button)`
  background: #00685F !important;
  border-radius: 5px;
  color: #ffffff !important;
  width: 100px;
   &:hover {
	  color: #ffffff !important;
  }
   &:focus {
	  color: #ffffff !important;
  }
`;

const StyledButtonCancel = styled(Button)`
  background: #ffffff !important;
  border-radius: 5px;
  color: #000000!important;
  width: 100px;
  border-color: #000000!important;
  &:focus {
      color: #000000 !important;
  }
`;

export const ViewClaims = ({
	isModalVisible,
	setIsModalVisible,
	addClaims,
	setaddClaims,
	viewClims,
	claimsDataSource,
	isViewClims,
	update,
	activeclaimsIds = [],
}) => {
	const userList = useSelector(getUserList);
	const [selectedKeys, setSelectedKeys] = useState(new Set());
	const [expandedRows, setExpandedRows] = useState({});

	useEffect(() => {
		if (update && addClaims?.length > 0) {
			const ids = new Set(addClaims.map((c) =>
				c?.claimsId?.claimsid
				?? c?.claimsid
				?? c?.claimsId
				?? c?.id
				?? c
			));
			setSelectedKeys(ids);
		}
	}, [update, addClaims]);

	const claimsColumns = [
		!isViewClims
			? {
				title: "Action",
				dataIndex: "action",
				key: "action",
				render: (_, record) => (
					<Checkbox
						checked={
							activeclaimsIds?.includes(record?.claimsid ?? record?.claimsId) ||
							selectedKeys.has(record?.claimsid ?? record?.claimsId ?? record?.id ?? record.key)
						}
						onChange={(e) =>
							handleCheckboxChange(
								e,
								record?.claimsid ?? record?.claimsId ?? record?.id ?? record.key
							)
						}
						disabled={activeclaimsIds?.includes(record?.claimsid ?? record?.claimsId)}
					/>
				),
			}
			: null,
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			width: 350,
			render: (description, record) => {
				const isExpanded = expandedRows[record.key];

				return (
					<div>
						<div
							style={{
								maxHeight: isExpanded ? "60px" : "48px",
								overflowY: isExpanded ? "auto" : "hidden",
								overflowX: "hidden",
								display: "-webkit-box",
								WebkitLineClamp: isExpanded ? "unset" : 2,
								WebkitBoxOrient: "vertical",
								wordBreak: "break-word",
								whiteSpace: "normal",
								lineHeight: "1.5",
								paddingRight: isExpanded ? "6px" : "0px",
							}}
						>
							{description || "-"}
						</div>

						{description && description?.length > 80 && (
							<span
								onClick={() =>
									setExpandedRows((prev) => ({
										...prev,
										[record.key]: !prev[record.key],
									}))
								}
								style={{
									color: "#397EF3",
									cursor: "pointer",
									fontSize: "13px",
									fontWeight: 500,
									marginTop: "4px",
									display: "inline-block",
								}}
							>
								{isExpanded ? "View Less" : "View More"}
							</span>
						)}
					</div>
				);
			},
		},
		{
			title: "VAT/Non-VAT",
			dataIndex: "taxtype",
			key: "taxtype",
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
		},
		{
			title: "Currency",
			dataIndex: "currency",
			key: "currency",
		},
		{
			title: "Amount",
			dataIndex: "amount",
			key: "amount",
			render: (_, record) => {
				const formattedAmount = new Intl.NumberFormat("en-US").format(
					Number(record?.totalamount ?? record?.amount) || 0
				);
				return <>{formattedAmount}</>;
			},
		},
		{
			title: "Submitted By",
			dataIndex: "submittedby",
			key: "submittedby",
			render: (_, record) => {
				if (record.submittedby) {
					return record.submittedby;
				}
				if (record.createdby) {
					const user = userList.find((u) => u.userid === record.createdby);
					return user ? user.fullname : record.createdby;
				}
				return "-";
			},
		},
		{
			title: "Timesheet Week",
			dataIndex: "week",
			key: "week",
			render: (_, record) => (
				<span style={{ color: "#397EF3" }}>
					{record.week ? generateNiceWeekFromWeek(record.week) : "-"}
				</span>
			),
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (_, record) => (
				<>
					{record.date
						? moment(record.date).format("DD-MM-YYYY")
						: record.dateoflog
							? moment(record.dateoflog).format("DD-MM-YYYY")
							: "-"}
				</>
			),
		},
	].filter(Boolean);

	const handleCheckboxChange = (e, key) => {
		setSelectedKeys((prevSelectedKeys) => {
			const newSelectedKeys = new Set(prevSelectedKeys);
			if (e.target.checked) {
				newSelectedKeys.add(key);
			} else {
				newSelectedKeys.delete(key);
			}
			return newSelectedKeys;
		});
	};

	const claimsData = claimsDataSource
    ?.filter((record) => {
        const id = record?.claimsid ?? record?.claimsId;
        return !activeclaimsIds?.includes(id);
    })
    ?.map((record, index) => ({
        ...record,
        key: record?.claimsid ?? record?.claimsId ?? record?.id ?? index,
    }));
	const handleSave = () => {
		const selectedRecords = claimsData.filter((record) =>
			selectedKeys.has(record.key)
		);

		const mapedRecords = selectedRecords.map((item) => ({
			date: new Date(item?.dateoflog) || "",
			submittedby: userList.find((u) => u.userid === item.createdby)?.fullname || "",
			amount: item?.totalamount || "0",
			claimsId: item?.claimsid || "",
			non_vat: item?.taxtype === "Non-VAT" ? true : false,
			vat: item?.taxtype === "VAT" ? true : false,
			description: item?.description || "",
			type: item?.type || "",
			attachments: item?.attachments || [],
			currency: item?.currency || "",
			remarks: item?.remarks || "",
			status: true,
			 taxtype: item?.taxtype || "", 
		}));

		setaddClaims(mapedRecords);
		handleCancel();
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		setSelectedKeys(new Set());
	};

	useEffect(() => {
		if (!isModalVisible) return;

		if (update && addClaims?.length > 0) {
			const ids = new Set(addClaims.map((c) =>
				c?.claimsId?.claimsid ?? c?.claimsid ?? c?.claimsId ?? c?.id ?? c
			));
			setSelectedKeys(ids);
		} else {
			setSelectedKeys(new Set()); // reset on fresh open
		}
	}, [isModalVisible]); // trigger on modal open/close

	return (
		<StyledClaimsModal
			visible={isModalVisible}
			onCancel={handleCancel}
			footer={false}
		>
			<h6>Select Claims:</h6>
			<Table
				dataSource={claimsData}
				columns={claimsColumns}
				rowKey={(record) => record.key}
				pagination={false}
				scroll={{ x: 1000, y: 600 }}
			/>
			{!isViewClims && (
				<div className="text-end mt-2">
					<StyledButtonCancel onClick={handleCancel}>Cancel</StyledButtonCancel>
					<StyledButton
						className="cursor-pointer"
						onClick={handleSave}
					>
						Save
					</StyledButton>
				</div>
			)}
		</StyledClaimsModal>
	);
};

const StyledClaimsModal = styled(Modal)`
  width: 1500px !important;
  z-index: 10;
  .ant-modal-header {
    text-transform: uppercase;
    max-width: 95%;
  }
  .ant-modal-body {
    overflow-y: auto;
    max-height: 85vh;
    padding-right: 16px;
  }
  ul.ant-pagination {
    display: none;
  }
  .ant-modal-close-x {
    display: none;
  }
`;
